import type { KambiBetOffer, KambiEvent, KambiListView, KambiLiveData } from '@mobi/api-types/kambi'
import { simpleFetch } from '@mobi/utils/fetch/simpleFetch'

export function getEventsForGroupId(groupId: number) {
  return simpleFetch<{ events: KambiEvent[] }>(
    `${window._kc.apiOfferingBaseUrl}event/group/${groupId}`
  )
}

export function getUpcomingEventsForAllSports() {
  return simpleFetch<KambiListView>(
    `${window._kc.apiOfferingBaseUrl}listView/all/all/all/all/starting-soon.json?lang=en_AU&market=AU&useCombined=true`
  )
}

export function getLiveEventsForAllSports() {
  return simpleFetch<KambiListView>(
    `${window._kc.apiOfferingBaseUrl}listView/all/all/all/all/in-play.json?lang=en_AU&market=AU&useCombined=true`
  )
}

export function getEventsBySportTermKey(sport: string) {
  return simpleFetch<{
    events: { event: KambiEvent; betOffers: KambiBetOffer[]; liveData: KambiLiveData }[]
  }>(
    `${window._kc.apiOfferingBaseUrl}listView/${sport}?lang=en_AU&market=AU&includeParticipants=false&useCombined=true&useCombinedLive=true`
  )
}
